module.exports = __webpack_public_path__ + "static/bag_of_holding_mtg_clb-31d45173ae81ff904f9de5b2a0257b5c.jpg";